<n-card-panel class="mt-20"
    [header]="false">
    <form [errorMessage]="errorMessage"
        [formGroup]="vm"
        class="common-form">
        <!-- 模式 -->
        <n-form-item [label]="i18n.worm.wormType">
            <div *ngIf="isCreateFs">
                <n-select id="worm_config_type" 
                    [options]="wormTypeOptions" 
                    formControlName="wormType"
                    *ngIf="!isHyperMetroPairWorm">
                </n-select>
                <span *ngIf="isHyperMetroPairWorm"> {{i18n.worm.enterprise}}</span>
            </div>
            <div class="text-lab" *ngIf="!isCreateFs">
                {{vm.get('wormType').value === wormTypeE.compliance ? i18n.worm.compliance : i18n.worm.enterprise}}
            </div>
            <div>
                <n-tip>
                    <span>{{vm.get('wormType').value === wormTypeE.compliance && !isHyperMetroPairWorm ? i18n.worm.wormTypeTips : i18n.worm.wormTypeEnterpriseTips}}</span>
                </n-tip>
            </div>
        </n-form-item>
        <!-- 保护期设置 -->
        <div class="protect-title">
            <span>{{i18n.worm.retentionLab}}</span>
            <n-help-icon [content]="i18n.worm.retentionTips"></n-help-icon>
        </div>
        <!-- 最小保护期 -->
        <n-form-item *ngIf="!disableMinMaxProtect" [label]="i18n.worm.minRetentionLab">
            <div class="interval-10">
                <n-spinner [onlyInput]="true"
                    id="worm_config_min_protect_period_val"
                    formControlName="wormMinProtectPeriod">
                </n-spinner>
                <n-select [options]="protectOptions"
                    id="worm_config_min_protect_period_unit"
                    class="unit"
                    formControlName="minProtectPeriodUnit">
                </n-select>
                <n-checkbox [label]="i18n.worm.infiniteEnableLab"
                    id="worm_config_min_protect_period_enable"
                    formControlName="minInfiniteEnable">
                </n-checkbox>
            </div>
        </n-form-item>
        <!-- 最大保护期 -->
        <n-form-item *ngIf="!disableMinMaxProtect" [label]="i18n.worm.maxRetentionLab">
            <div class="interval-10">
                <n-spinner [onlyInput]="true"
                    id="worm_config_max_protect_period_val"
                    min='1'
                    formControlName="wormMaxProtectPeriod">
                </n-spinner>
                <n-select [options]="protectOptions"
                    id="worm_config_max_protect_period_unit"
                    class="unit"
                    formControlName="maxProtectPeriodUnit">
                </n-select>
                <n-checkbox [label]="i18n.worm.infiniteEnableLab"
                    id="worm_config_max_protect_period_enable"
                    formControlName="maxInfiniteEnable"
                    [disabled]="!canChange"
                    (onChange)="infiniteChanged($event, 'wormMaxProtectPeriod', 'maxProtectPeriodUnit')">
                </n-checkbox>
            </div>
        </n-form-item>
        <!-- 默认保护期 -->
        <n-form-item [label]="i18n.worm.defRetentionLab">
            <div class="interval-10" style="width: 3rem">
                <n-spinner [onlyInput]="true"
                    id="worm_config_def_protect_period_val"
                    formControlName="wormDefProtectPeriod"
                    (onFocus)="clearVerification('defInfiniteEnable')">
                </n-spinner>
                <n-select [options]="protectOptions"
                    id="worm_config_def_protect_period_unit"
                    class="unit"
                    formControlName="defProtectPeriodUnit">
                </n-select>
                <n-checkbox [label]="i18n.worm.infiniteEnableLab"
                    id="worm_config_def_protect_period_enable"
                    formControlName="defInfiniteEnable"
                    [disabled]="!canChange"
                    (onChange)="infiniteChanged($event, 'wormDefProtectPeriod', 'defProtectPeriodUnit')">
                </n-checkbox>
            </div>
        </n-form-item>
        <!-- 自动锁定 -->
        <n-form-item [label]="i18n.worm.autoLockLab">
            <n-checkbox
                id="worm_auto_lock_id"
                [label]="i18n.worm.enableLab"
                formControlName="wormAutoLock">
            </n-checkbox>
            <n-tip *ngIf="!vm.get('wormAutoLock').value">
                <span>{{i18n.worm.autoLockEnableTips}}</span>
            </n-tip>
        </n-form-item>
        <!-- 锁定等待时长 -->
        <n-form-item *ngIf="vm.get('wormAutoLock').value"
            [label]="i18n.worm.lockWaiteTimeLab">
            <div class="interval-10 custom-width">
                <n-spinner
                    id="worm_auto_lock_time_id"
                    [onlyInput]="true"
                    min="1"
                    formControlName="wormAutoLockTime">
                </n-spinner>
                <n-select [options]="autoLockOptions"
                    id="worm_auto_lock_time_unit_id"
                    class="unit"
                    formControlName="autoLockTimeUnit">
                </n-select>
            </div>
            <n-tip>
                <span>{{i18n.worm.lockWaiteTimeTips}}</span>
            </n-tip>
        </n-form-item>
        <!-- 自动删除 -->
        <n-form-item [label]="i18n.worm.autoDeleteLab">
            <n-checkbox
                id="worm_auto_del_id"
                [label]="i18n.worm.enableLab"
                formControlName="wormAutoDel">
            </n-checkbox>
            <n-tip>
                <span>{{i18n.worm.autoDeleteTips}}</span>
            </n-tip>
        </n-form-item>
        <!-- 是否worm审计日志文件系统 -->
        <n-form-item [label]="i18n.worm.wormLogLab" *ngIf="!isHyperMetroPairWorm && vm?.value.wormType !== wormTypeE.enterprise">
            <n-checkbox
                id="worm_audit_log_enable_id"
                [label]="i18n.worm.enableLab"
                formControlName="isWormAuditLogFs">
            </n-checkbox>
            <n-tip>
                <span>{{i18n.worm.paraAuditFsInfo}}</span>
            </n-tip>
        </n-form-item>
        <!-- 初始化时钟 -->
        <n-form-item *ngIf="hasWormClockW && !globalClockInitialized"
            [label]="i18n.worm.initClocks">
            <n-checkbox
                id="worm_global_clock_id"
                [label]="i18n.worm.enableLab"
                formControlName="initWormClock">
            </n-checkbox>
            <div *ngIf="vm.get('initWormClock').value">
                <span>{{i18n.worm.correntTimeLab}}</span>
                <span>{{timeStr || UNPLACEHOLDER}}</span>
            </div>
            <n-tip type="warning">
                <span>{{i18n.worm.initClocksTip}}</span>
            </n-tip>
        </n-form-item>
    </form>
    <n-loading [visible]="loading"></n-loading>
</n-card-panel>
